import "../assets/styles/Header.scss";
// const apiUrl = import.meta.env.VITE_API_URL;

const Header: React.FC = () => {
  // console.log("Running in mode:", import.meta.env.MODE);
  // console.log("API URL:", apiUrl);
  // console.log("ENV:", import.meta.env);


  return (
    <header className="header">
      <div className="header-main">
        <div className="logo">
          <img
            src="https://www.docprime.com/assets/images/logo.png"
            alt="logo"
            width={"60px"}
          />
        </div>
        {/* <nav className="nav">
          <ul>
            <li>
              <a href="/">Sign In</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </nav> */}
      </div>
    </header>
  );
};

export default Header;
